'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    'connector-enclosed': [{
        base: '/static/assets/images/bild-1.1.png',
        ids: ['eh', 'tb', 's', 'z1', 'z2']
    }, {
        base: '/static/assets/images/bild-2.2.png',
        ids: ['kt1', 'm', 'z3']
    }],
    'connector-55': [{
        base: '/static/assets/images/bild-1.2.png',
        ids: ['eh', 'tb', 's', 'z1', 'z2']
    }, {
        base: '/static/assets/images/bild-2.2.png',
        ids: ['kt1', 'm', 'z3']
    }],
    'connector-110': [{
        base: '/static/assets/images/bild-1.2.png',
        ids: ['eh', 'tb', 's', 'z1', 'z2']
    }, {
        base: '/static/assets/images/bild-2.1.png',
        ids: ['kt1', 'm', 'z3']
    }],
    'connector-niche': [{
        base: '/static/assets/images/bild-1.2.png',
        ids: ['eh', 'tb', 's', 'z1', 'z2']
    }, {
        base: '/static/assets/images/bild-2.2.png',
        ids: ['kt1', 'm', 'z3']
    }]
};


//////////////////
// WEBPACK FOOTER
// ./client/components/connector-form/graph-configs.js
// module id = 488
// module chunks = 0